import type React from 'react';

import { Alert } from '@change/ds-core-ui/Alert';

import { Translate } from '@change-corgi/core-react/i18n';

const DeleteSuccessMessage: React.FC<EmptyProps> = () => {
	return (
		<Alert
			variant="success"
			heading={<Translate value="corgi.petition_feed.delete_video.success_heading" />}
			className="mb-2"
		>
			<Translate value="corgi.petition_feed.delete_video.success_body" />
		</Alert>
	);
};

const DeleteErrorMessage: React.FC<EmptyProps> = () => {
	return (
		<Alert
			variant="warning"
			heading={<Translate value="corgi.petition_feed.delete_video.error_heading" />}
			className="mb-2"
		>
			<Translate value="corgi.petition_feed.delete_video.error_body" />
		</Alert>
	);
};

export const PetitionVideoDeleteMessage: React.FC<{
	message: 'success' | 'error' | undefined;
}> = ({ message }) => {
	if (message === 'success') return <DeleteSuccessMessage />;
	if (message === 'error') return <DeleteErrorMessage />;
	return null;
};
